import { email, password, required, Validator } from '@/entities/validation';
import { User } from './model';

export const validate: Validator<User> = record => [
  ...required(record.name, 'name'),
  ...email(record.email, 'email'),
  ...(record.password ? password(record.password, 'password') : []),
];
